require ('./ChatUnavailable.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { chain, remove } = require('lodash');
const moment = require('moment');
// @utilities
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
//  constants
const { SPANISH_DAYS } = require('constants/index'); 

class ChatUnavailable extends React.Component {

    constructor(props) {
        super(props);
        this.buildMsgContent = this.buildMsgContent.bind(this);
        this.getLocaleDaysFromSpanish = this.getLocaleDaysFromSpanish.bind(this);
    }

    getLocaleDaysFromSpanish(day) {
        return moment().day(SPANISH_DAYS.indexOf(day) + 1).locale(getLanguage()).format('dddd');
    }

    buildMsgContent(workableAgentList) {
        return workableAgentList.map((group, index) =>{
            let msgContent;
            if (group && group.value.length) {
                const startTime = DateHelper.getTimeFormated(group.value[0].from);
                const endTime = DateHelper.getTimeFormated(group.value[0].to);
                const startDay = this.getLocaleDaysFromSpanish(group.value[0].day);
                const lastDay = this.getLocaleDaysFromSpanish(group.value[group.value.length-1].day);
                let splitChar = '';
                if (index === workableAgentList.length - 1 || workableAgentList.length === 1) {
                    splitChar = '.'
                } else if (workableAgentList.length > 1) {
                    if (index === workableAgentList.length - 2) {
                        splitChar = ' ' + formatText("chatUnavailable-splitCharacter") + ' ';
                    } else {
                        splitChar = ", ";
                    }
                }
                if (group.value.length === 1) {
                    msgContent = (
                        <FormattedText
                            value="chatUnavailable-oneDayMessage"
                            injectedStrings={[startTime, endTime, startDay, splitChar]}
                        />
                    );
                } else {
                    msgContent = (
                        <FormattedText
                            value="chatUnavailable-multipleDaysMessage"
                            injectedStrings={[startTime, endTime, startDay, lastDay, splitChar]}
                        />
                    );
                }
                return msgContent;
            }
        });
    }

    render() {
        const { chatAvailabilityStatusData } = this.props;
        let agentList = chatAvailabilityStatusData && chatAvailabilityStatusData.get('supportSchedule').toJS();
        let from, to, group = 0;
        agentList.forEach(function( obj ) {
            if (obj.workable) {
                if (obj.to !== to || obj.from !== from) {
                    group++;
                }
                to = obj.to;
                from = obj.from;
                obj.group = group;
            } else {
                to = 0;
                from = 0;
            }
        });
        let workableAgentList =  chain(agentList)
                                .groupBy('group')
                                .map((value, group) => ((group !== "undefined") && { value, group }))
                                .value();
        //_.remove is used to create new array with required values
        workableAgentList = remove(workableAgentList, (group)=>{
            return group;
        })

        let msgContent = workableAgentList.length ? <FormattedText value="chatUnavailable-initialMessage"/> : '';
        let extraMsgContent = this.buildMsgContent(workableAgentList);
        let contactUsMessageContent = workableAgentList.length ? <FormattedText value="chatUnavailable-contactUsMessage"/> : '';
       
        return (
            <div className="chat-unavailable">
                <div className="chat-unavailable__icon">
                    <i className="icon-tiempo" />
                </div>
                <div className="chat-unavailable__text">
                    <h4 className="chat-unavailable__title">
                        <FormattedText value="chatUnavailable-messageTitle"/>
                    </h4>
                    <div className="chat-unavailable__message">
                        <span className="chat-unavailable__msg-content">{msgContent}</span>
                        {extraMsgContent}
                        {contactUsMessageContent}
                    </div>
                </div>
            </div>
        );
    }
}

ChatUnavailable.propTypes = {
    chatAvailabilityStatusData: PropTypes.object.isRequired
};

module.exports = ChatUnavailable;
